import React, { useState, useEffect } from "react";
import "./riderCurrentOrder.css";
import { Tooltip, Typography, Select, Button, Pagination } from "antd";
import {InfoCircleOutlined, SearchOutlined, ShopOutlined} from "@ant-design/icons";
import * as zoneActions from "../../../redux/actions/zone.actions";
import * as dashboardActions from "../../../redux/actions/dashboard.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Pageloader from "../../../components/loader";
import moment from "moment";
import {getRidingTracking} from "../../../services/orderManagement.service";
import {swalNotification} from "../../../components/alret/notificztion";
const { Text, Title } = Typography;
const { Option } = Select;


const RiderCurrentOrder = (props) => {
  const pagename = "Rider Current Orders";
  const [loading, setLoading] = useState(true);
  const [postDataZone, setPostDataZone] = useState(null);
  const [sortedData, setSortedData] = useState([]);
  const [zoneIdData, setZoneIdData] = useState();


  useEffect(() => {
    postLists()
  }, []);
  const postLists = async () => {
    try {
      setLoading(true);
      await props.zoneActions.getZoneListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.map((item) => {zoneData.push(<Option key={item.id}>{item.zoneName}</Option>)});
      setPostDataZone(zoneData);
    }
  }, [props.zoneData]);

  const handleChangeZone = async (value) => {
    try {
      setLoading(true);
      setZoneIdData(value);
      console.log(value)

      await props.dashboardActions.getRiderCurrentOrderZoneActionV2("", value);
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  const rlocdir = async (value, valLat, valLon)=>{
    try{
      console.log(value, valLat, valLon)
      const res = await getRidingTracking(value)
      if (res.data.code === 200 && res.data.data.length > 0){
        const resloc = res.data.data[0]
        return window.open(`https://www.google.com/maps/dir/${resloc.lat},${resloc.lon}/${valLat},${valLon}`);
      } else {
        swalNotification("", "Rider location not found", "error" )
      }
    } catch{}
  }

  const searchAgain = async () => {
    try {
      setLoading(true);
      await props.dashboardActions.getRiderCurrentOrderActionV2("", zoneIdData);
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.riderCurrentOrder) {
      setSortedData(props.riderCurrentOrder)
      // console.log("data", props.riderCurrentOrder)
    }
  }, [props.riderCurrentOrder]);

  const paginationChange = async (page, limit) => {
    const pagi = {
      Page: page,
      limit: limit,
    };
    // await props.orderManagementActions.putStoreIdsFilterAction(pageData);
  };


  const riderHighlight = (scheduled_end_time) => {

    var end = moment.unix(scheduled_end_time);
    var startTime = moment();
    var duration = moment.duration(end.diff(startTime));

    if(duration.asMinutes() <= 30){
      return 'ant-typography ant-typography-danger';
    }

    return '';

  }

  const riderStatus = (item) => {

    if(item.shiftStatusLog == null){
      return "Offline";
    }
    // console.log(item.rider);
    if(item.rider.work_status == "free" && item.rider.reached_mart == false && item.shiftStatusLog == "started"){
        return "Free - Returning to Mart";
    }

    if(item.rider.work_status == "free" && item.rider.reached_mart == true && item.shiftStatusLog == "started"){
      return "Free - At Mart";
    }

    if(item.on_route_orders > 0){
      return "Busy - On-route";
    }

    if(item.rider.work_status == "break") {
      return "On-Break";
    }

    return '-';

  };

  const riderStatusStyle = (item) => {

      if(item.shiftStatusLog == null) {return {color: '#FF0000'}}
      if(item.rider.work_status == "free" && item.rider.reached_mart == false && item.shiftStatusLog == "started"){ return {color: '#FFA500'} }
      if(item.rider.work_status == "free" && item.rider.reached_mart == true && item.shiftStatusLog == "started"){ return {color: '#008000'} }
      if(item.on_route_orders > 0){ return {color: '#964B00'} }
      if(item.rider.work_status == "break") { return {color: '#0000FF'} }
      return null
  };


  return (
      <div className="page-content">
        <div className="page-content-header">
          <div className="pch">
            <Title level={2}>{pagename}</Title>
          </div>
          <div className="pch">
            <Select
                showSearch
                // mode="multiple"
                allowClear
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    || option.props.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                defaultValue={props.id}
                value={props.id}
                placeholder="Please select Zone"
                onChange={handleChangeZone}
                style={{ minWidth: 300,}}
            >
              {postDataZone}
            </Select>
            <Button style={{ marginBottom: "0" }} onClick={() => searchAgain()}>Search<SearchOutlined /></Button>
          </div>
        </div>
        <div className="p-content">
          {loading == true ? <Pageloader /> :
              <div className="customTable fixTableHead">
                <table>
                  <thead>
                  <tr>
                    <th>Active Rider</th>
                    <th>Total order <Tooltip placement="topRight"
                                             title="All orders currently in rider's stack in any state (Accepted + Pickup Started + Pickup Reached + Pickup Successful + Dropoff Started + Dropoff Reached)"><InfoCircleOutlined/></Tooltip>
                    </th>
                    {/* <th>Assigned order</th> */}
                    <th>Pending pickup <Tooltip placement="topRight"
                                                title="Pickup Started + Pickup Reached + Accepted"><InfoCircleOutlined/></Tooltip>
                    </th>
                    <th>Pickup successful</th>
                    <th>On route orders <Tooltip placement="topRight"
                                                 title="Dropoff Started + Dropoff Reached "><InfoCircleOutlined/></Tooltip>
                    </th>
                    <th>Wating at Mart <Tooltip placement="topRight"
                                                title="Current Time - Reached Mart press time"><InfoCircleOutlined/></Tooltip>
                    </th>
                    <th>Idle Time <Tooltip placement="topRight"
                                           title="Current Time - Last Order Delivered Time"><InfoCircleOutlined/></Tooltip>
                    </th>
                    <th>Rider’s Statuses <Tooltip placement="topRight"
                                                    title=""><InfoCircleOutlined/></Tooltip>
                    </th>
                    <th>Scheduled End Time <Tooltip placement="topRight"
                                                    title=""><InfoCircleOutlined/></Tooltip>
                    </th>
                  </tr>
                  </thead>
                  {sortedData.length === 0 ?
                      <tbody>
                      <tr>
                        <td colSpan={7} style={{textAlign: "center" }}>Please Select Zone</td></tr></tbody>:
                      <tbody>
                      {sortedData.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {item && item.rider ? item.rider.display_id + " - " + item.rider.fullName : "-"}
                              {(item.rider.work_status == "free" && item.rider.reached_mart == false && item.shiftStatusLog == "started") ?
                                  <span style={{paddingLeft: "5px"}}>{item.rider && item.orderPickup ?
                                      <a onClick={() => rlocdir(item.rider._id, item.orderPickup.latitude, item.orderPickup.longitude)}>
                                        <Tooltip title={"Store location"}><ShopOutlined/></Tooltip></a> : ""}
                                  </span>
                                : ""}
                            </td>
                            <td>{item && item.total_orders ? item.total_orders : "-"}</td>
                            {/* <td>{item && item.assigned_orders?item.assigned_orders:"-"}</td> */}
                            <td>{item && item.pending_pickup?item.pending_pickup:"-"}</td>
                            <td>{item && item.pickup_successful?item.pickup_successful:"-"}</td>
                            <td>{item && item.on_route_orders?item.on_route_orders:"-"}</td>
                            <td>{item && (item.waiting_at_mart && item.shiftStatusLog != null) ? item.waiting_at_mart > 10? <Text type="danger">{item.waiting_at_mart.toFixed()+" mins"}</Text> :item.waiting_at_mart.toFixed()+" mins":"-"}
                            </td>
                            <td>
                              {item && (item.idle_time && item.shiftStatusLog != null) ?
                                  item && item.on_route_orders ?"-":item.idle_time > 20? <Text type="danger">{item.idle_time.toFixed()+" mins"}</Text>:item.idle_time.toFixed()+" mins"
                                  :"-"}
                            </td>
                            <td style={riderStatusStyle(item)}>
                              <span>{riderStatus(item)}</span>
                            </td>
                            <td className={riderHighlight(item.scheduled_end_time_last)}>
                              {moment.unix(item.scheduled_end_time_last).format("DD MMMM, yyyy h:mm A")}
                            </td>
                          </tr>
                      ))}
                      </tbody>
                  }
                </table>
                {/* <Pagination className="ant-table-pagination ant-table-pagination-right"
              total={props.taskPagination && props.taskPagination.totalCount ? props.taskPagination.totalCount : "0"}
              showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
              pageSize={props.taskPagination && props.taskPagination.limit ? props.taskPagination.limit : "10"}
              defaultCurrent={props.taskPagination && props.taskPagination.currentPage ? props.taskPagination.currentPage : "1"} 
              pageSizeOptions={["10", "20", "30", "40", "50"]}
              showSizeChanger={true}
              onChange={(currentPage, pageSize) => {paginationChange(currentPage, pageSize)}}
            /> */}
              </div>
          }
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    // dashboardFilter: state.ZoneReducer.dashboardFilter,
    riderCurrentOrder: state.DashboardReducer.riderCurrentOrder,
    storeID: state.DashboardReducer.riderCurrentOrderStore
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RiderCurrentOrder);